import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const tokenExistente = this.authService.getToken();
    const autenticado = this.authService.isAuthenticated();

    if (autenticado && tokenExistente) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${tokenExistente}`),
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const sessaoExpirada = tokenExistente && !autenticado;

        if (error.status === 401 || (error.status === 403 && sessaoExpirada)) {
          this.authService.clearSession();
          this.router
            .navigate(['/auth/session-expired'])
            .then(() =>
              console.info(
                'Sessão expirada. Redirecionando para tela de sessão expirada.',
              ),
            );
        } else if (error.status === 403) {
          this.router
            .navigate(['/auth/access-denied'])
            .then(() =>
              console.info(
                'Acesso negado. Usuário não possui permissão para acessar este recurso.',
              ),
            );
        }
        return throwError(() => error);
      }),
    );
  }
}
